export const endpoints = {
  register: () => "/register",
  login: () => "/login",
  forgotPassword: () => "/forget-password",
  verifyOtp: () => "/verify-otp",
  resetPassword: () => "/reset-password",
  updateUserProfile: (id) => `/user/profile/${id}`,
  updateCorporateProfile: (id) => `/corporate/profile/${id}`,
  updateProfessionalProfile: (id) => `/professional/profile/${id}`,
  professionalAddServices: () => "/service",
  professionalAddServicesShow: (id) => `/service/user/${id}`,
  professionalAddServiceUpdate: (id) => `/service/${id}`,
  professionalDeleteService: (id) => `/service/${id}`,
  coporateAddEmploye: (id) => `/corporate/${id}/employee`,
  coporateShowEmployees: (id, page) => `/corporate/${id}/employee?page=${page}`,
  coporateShowSingleEmployees: (id, employee_id) =>
    `/corporate/${id}/employee/${employee_id}`,
  coporateUpdateEmployees: (id, employee_id) =>
    `/corporate/${id}/employee/${employee_id}`,
  coporateEmployeesStatus: (id, employee_id, status) =>
    `/corporate/${id}/employee/${employee_id}/${status}`,
  professionalAddTimingShedule: () => "/professional/schedule",
  updateProfessionalEditTimeSlot: () => "/professional/schedule/update",
  professionalShowTimingShedule: (id) => `/professional/schedule/${id}`,
  deleteSchadule: (id) =>  `/professional/schedule/${id}`,
  sendMessage: "/send/message",
  getMessages: "/get/messages/",
  getConversations: "/conversations/",
  getNotifications: (id, page) => `/notifications/${id}?page=${page}`,
  getRequest: (id) => `/request/${id}`,
  getNotificationDetail: `/notification/`,
  searchFilter: () => "/frontend/filter",
  popularProfessional: () => `/frontend/popular/professional`,
  workerDetail: (id) => `/frontend/user/${id}`,
  sendReqToWorker: () => "/user/request",
  requestStatus: `/professional/request`,
  rescheduleRequest: "/user/request/reschedule",
  changePassword: () => "/setting/reset-password",
  getEmployeServices: (id) => `/service/${id}`,
  getAllCorporates: (payload) =>
    `/admin/corporate?page=${payload?.page}&search=${payload?.search}`,
  getAllProfessionals: (payload) =>
    `/admin/professional?page=${payload?.page}&search=${payload?.search}`,
  getAllUsers: (payload) =>
    `/admin/user?page=${payload?.page}&search=${payload?.search}`,
  updateCorporateStatus: (id, status) =>
    `/admin/corporate/status/${status}/update/${id}`,
  updateProfessionalStatus: (id, status) =>
    `/admin/professional/status/${status}/update/${id}`,
  updateUserStatus: (id, status) => `/admin/user/status/${status}/update/${id}`,
  getSongleCorporate: (id) => `/admin/corporate/${id}`,
  getSingleProfessional: (id) => `/admin/professional/${id}`,
  getSingleUser: (id) => `/admin/user/${id}`,
  verifyEmailAddress: (id) => `/verify/email/${id}`,
  profileReview: (page) => `/admin/review/profiles?page=${page}`,
  profileReviewStatus: () => `/admin/review/profile/status`,
  getSingleProfile: (id) => `/admin/review/profile/${id}`,
  getAvailedServices: (id, page) => `/user/${id}/availservices?page=${page}`,
  getAvailedServiceDetail: (id) => `/request/${id}`,
  sendFeedback: () => `/user/feedback`,
  getFeedbacks: (userId, currentPage) =>
    `/professional/feedback/${userId}?page=${currentPage}`,
  superAdminStats: () => "/admin/statistics",
  corporatesStats: (id) => `/corporate/${id}/statistics`,
  subcriptionSession: () => `/plans/subscribe`,
  getPlans: (role) => `/plans/${role}`,
  feedbackReply: () => `/user/feedback/reply`,
  checkApiStatus: () => "/check/subscription-status",
  cancelSubscription: () => "/plans/subscription/cancel",
  getAuthUser: (id) => `/auth/user/${id}`,
};
